<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "WebTabDeleted",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.webTabDeleted', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                tabName: this.$_.get(this.activity, 'payload.tabName'),
                placement: this.$_.get(this.activity, 'payload.tabPlacement')
            });
        }
    }
};
</script>


